export default {"src":"/_next/static/media/gq-wordmark.98c3d7a9.svg","height":69,"width":108,"blurWidth":0,"blurHeight":0};